// extracted by mini-css-extract-plugin
export default {"themeText":"var(--text)","icon":"Links-module_icon__3F4Dq"};